export const getRouteDirectionLink = (fromAuto, toAuto) => {
  return `https://www.google.com/maps/dir/?api=1&origin=${fromAuto?.lat},${fromAuto?.lng}&destination=${toAuto?.lat},${toAuto?.lng}&travelmode=driving`
}
